import MailList from './MailList';

export default MailList;


// WEBPACK FOOTER //
// /src/components/mailList/index.js